import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import accountStyles from './account-option.style';
import { useState } from 'react';
import { msgAlertInput } from 'constants/messageAlert';
import { useForm } from 'react-hook-form';
import DatePicker from 'components/date-picker/DatePicker';
import LoadingIcon from 'components/loading/LoadingIcon';
import moment from 'moment';
import { BonusReportSearchPayload, FundTransferItem } from 'models/fundTransferModel';
import userApi from 'apis/userApi';
import Pagination from 'components/pagination/Pagination';
import toast from 'react-hot-toast';
import { InfoPaginate } from 'models/commonModel';
import { scrollToTopPage } from 'utils/function';
const typelist = [
    {
        value: -2,
        label: 'Toàn bộ',
    },
    {
        value: 13,
        label: 'Tặng quà',
    },
    {
        value: 17,
        label: 'Nạp tiền từ cấp trên',
    },
    {
        value: 10,
        label: 'Nạp tiền cho cấp dưới',
    },
    {
        value: 53,
        label: 'Khuyến mãi của tôi',
    },
    {
        value: 54,
        label: 'Hoa hồng của tôi',
    },
    {
        value: 51,
        label: 'Hoa hồng cấp dưới',
    },
    {
        value: 19,
        label: 'Vòng quay may mắn',
    },
];
interface FormValues {
    loginname: string;
}

function PresentDetail() {
    const [startTime, setStartTime] = useState<Date | null>(new Date());
    const [endTime, setEndTime] = useState<Date | null>(new Date());
    const [typeSelectValue, setTypeselectValue] = useState(-2);
    const [loading, setLoading] = useState(false);
    const [loginname, setLoginname] = useState('');
    const [infoPage, setInfoPage] = useState<InfoPaginate | null>(null);
    const [bonusList, setBonusList] = useState<FundTransferItem[] | null>(null);
    const {
        formState: { errors },
        setError,
        clearErrors,
    } = useForm<FormValues>();

    const handleChangeLoginName = (value: string) => {
        if (!msgAlertInput.username.pattern.test(value) && value) {
            setError('loginname', {
                message: msgAlertInput.username.invalid,
            });
        } else {
            if (errors['loginname']) {
                clearErrors('loginname');
            }
        }
        setLoginname(value);
    };

    const searchBonusReport = async (page: number, isResetPaginate: boolean, type: 'btnSearch' | 'inputPage') => {
        if (isResetPaginate) {
            setInfoPage(null);
        }
        setLoading(true);
        let payload: BonusReportSearchPayload = {
            type: Number(typeSelectValue),
            loginname,
            stime: startTime ? moment(startTime).format('yyyy-MM-DD') : '',
            etime: endTime ? moment(endTime).format('yyyy-MM-DD') : '',
            pagesize: 10,
        };

        if (type === 'inputPage') {
            payload = {
                ...payload,
                curpage: infoPage?.curpage,
                num: page,
            };
        }
        try {
            const { data } = await userApi.bonusReportBean(payload, type);
            if (!data.msg) {
                setBonusList(data.reslist);
                const { curpage, totalpage, totalrecord } = data;
                setInfoPage({ curpage, totalpage, totalrecord });
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const mapLabelType = (type: number) => {
        const typeItem = typelist.find((list) => list.value === type);
        return typeItem?.label || '';
    };

    const handleChangePage = (page: number) => {
        searchBonusReport(page, false, 'inputPage');
        scrollToTopPage();
    };
    return (
        <>
            <div className={`${styles.wrap}`}>
                <div className={styles.containerBox}>
                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={styles.wrapInput}>
                                <DatePicker dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} noneStyle />
                            </div>
                        </div>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Tên Tài khoản</label>
                            <div className={styles.wrapInput}>
                                <input value={loginname} onChange={(e) => handleChangeLoginName(e.target.value)} type="text" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label className={styles.none}>{'___'}</label>
                            <div className={styles.groupInputTo}>
                                <div className="centerView">
                                    <label htmlFor="">Đến</label>
                                </div>
                                <div className={styles.wrapInput}>
                                    <DatePicker dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} noneStyle />
                                </div>
                            </div>
                        </div>
                        <div style={{ marginLeft: 40 }} className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Loại Hình</label>
                            <div className={styles.wrapInput}>
                                <select value={typeSelectValue} onChange={(e) => setTypeselectValue(Number(e.target.value))}>
                                    {typelist.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div />
                        <button type="button" className={styles.btnSubmit} onClick={() => searchBonusReport(1, true, 'btnSearch')}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>

                <div className={styles.containerTable}>
                    <div className={styles.table}>
                        <div className="row">
                            <div className="title col">Thời Gian</div>
                            <div className="title col">Tên Tài Khoản</div>
                            <div className="title col">Loại Hình</div>
                            <div className="title col">Thu Nhập</div>
                            <div className="title col">Chi</div>
                            <div className="title col">Ghi Chú</div>
                        </div>
                        {bonusList?.length ? (
                            bonusList.map((mem) => (
                                <div className="row" key={mem.id}>
                                    <p className="col">{moment(mem.inserttime).format('DD/MM/yyyy HH:mm')}</p>
                                    <p className="col">{mem.loginname}</p>
                                    <p className="col">{mapLabelType(mem.opttype)}</p>
                                    <p className="col text-success">{new Intl.NumberFormat().format(mem.income)}</p>
                                    <p className="col text-error">{new Intl.NumberFormat().format(mem.pay)}</p>
                                    <p className="col">{Number(mem.remark) === 0 ? '' : <span>{mem.remark.substring(0, 20)}...</span>}</p>
                                </div>
                            ))
                        ) : (
                            <div className="no-data" />
                        )}
                    </div>
                </div>

                {infoPage && (
                    <div className="pagination-common">
                        <div className=""></div>
                        <Pagination infoPage={infoPage} onChangePage={handleChangePage} showTotal />
                    </div>
                )}
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    groupAmount: css`
        display: flex;
        gap: 12px;
    `,
    itemBox: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        label {
            font-weight: 300;
            font-size: 17px;
            width: 100%;
        }
    `,
    none: css`
        color: transparent;
    `,
    btnSubmit: css`
        background: #ffad33 !important;
        border-radius: 3px !important;
        border: 1px solid #c9820a !important;
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 130px;
        margin-left: 40px;
        margin-bottom: 20px;
    `,
    containerBox: css`
        background-color: #f9f9f9;
        padding: 15px 40px 8px;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        margin-bottom: 15px;
        border-left: 3px solid #ebc85e;
        display: flex;
    `,
    groupInputTo: css`
        position: relative;
        display: flex;
        align-items: flex-end;
        margin-bottom: 4px;
        width: 100%;
        .centerView {
            width: 40px;
            text-align: center;
        }
    `,
    flex30: css`
        flex: 0 0 calc(30% - 24px);
    `,
    flex40: css`
        flex: 0 0 calc(40% - 24px);
    `,
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding: 20px;
    `,
    containerTable: css`
        background-color: #f2f2f2;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        border-radius: 5px;
        padding: 4px 4px 18px;
        margin-bottom: 100px;
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
    wrapInput: css`
        color: black;
        display: flex;
        flex: 1;
        width: 300px;
        input {
            border: none;
            height: 40px;
            border-bottom: 1px solid black;
            padding-left: 10px;
            background-color: white;
            width: 100%;
        }
        select {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
            width: 100%;
            color: black;
            box-shadow: none;
            outline: none;
            padding-left: 5px;
            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    `,
};

export default PresentDetail;
